// Module
var code = "<div class=\"spinner-icon\"></div> ";
// Exports
module.exports = code;